import request from "../utils/request";


export function fetchPortalMap() {
  return request({
    url: '/systems/portal',
    method: 'get'
  })
}

export function fetchSocialMap() {
  return request({
    url: '/systems/social',
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/system.js